import { render, staticRenderFns } from "./GXModelView.vue?vue&type=template&id=771eb3bc&scoped=true"
import script from "./GXModelView.vue?vue&type=script&lang=js"
export * from "./GXModelView.vue?vue&type=script&lang=js"
import style0 from "./GXModelView.vue?vue&type=style&index=0&id=771eb3bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771eb3bc",
  null
  
)

export default component.exports